import { useMutation } from 'react-query';
import { mobileVerification } from '~/api/mobileVerification';

export const useMobileVerification = () => useMutation(mobileVerification);
